module.exports = __webpack_public_path__ + "img/042.2448eddc.jpg";